<script setup lang="ts">
import { computed } from 'vue'

import ErrorList from './ErrorList.vue';

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

const props = withDefaults(
  defineProps<{
    id?: string
    modelValue: boolean | null
    errors?: string[]
  }>(),
  {}
)

const onChange = (evt: Event) => {
  emit('update:modelValue', (evt!.target as HTMLInputElement)!.checked)
}

const hasErrors = computed(() => props.errors && props.errors?.length > 0)
</script>

<template>
  <div class="flex flex-col mt-2 space-y-2 min-h-[70px]">
    <div class="flex items-center">
      <input
        :id="props.id"
        :class="['form-checkbox', { error: hasErrors }]"
        type="checkbox"
        :checked="!!props.modelValue"
        @change="onChange"
      />
      <label
        class="ml-2"
        :for="props.id"
        :class="{ 'error': hasErrors }"
        ><slot
      /></label>
    </div>
    <ErrorList :errors="props.errors" />
  </div>
</template>

<style scoped>
</style>
